var _path, _path2, _path3, _path4, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGraduationCapProfile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.97982 1.55859L16.3898 4.76916L8.97982 7.97972L1.56982 4.76916L8.97982 1.55859Z",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M4.93213 6.23438L4.93947 9.72757C4.93947 9.72757 6.16286 11.3466 8.97968 11.3466C11.7965 11.3466 13.0264 9.72757 13.0264 9.72757L13.0257 6.23438",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93262 12.0864V5.37109",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.93319 14.8127C3.68616 14.8127 4.29656 14.2023 4.29656 13.4493C4.29656 12.6963 3.68616 12.0859 2.93319 12.0859C2.18023 12.0859 1.56982 12.6963 1.56982 13.4493C1.56982 14.2023 2.18023 14.8127 2.93319 14.8127Z",
    stroke: "#949A9E",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 2.06982,
    y: 12.5859,
    width: 1.72674,
    height: 1.72674,
    stroke: "#949A9E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGraduationCapProfile);
export default __webpack_public_path__ + "static/media/graduation-cap-profile.bb0072970f7c513ff4fe5a8e9168fabf.svg";
export { ForwardRef as ReactComponent };